import React, { useEffect } from 'react';
import BeerBottelGlassIcon from '../../../icons/BeerBottelGlass.svg';
import { Container, Form, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import Button from '@material-ui/core/Button';
import { object, string } from 'yup';
import { ThemeProvider, createTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import InputTheme from './Helpers/InputTheme';
import SvgIcon from '@material-ui/core/SvgIcon';
import { SelectInput, StyledRadioInput } from '../../Helpers/Inputs';
import getMonth from '../../Helpers/Lists/Months';
import getYear from '../../Helpers/Lists/Years';
import './AlcoholDrugAbuse.scss';

const useStyles = makeStyles(theme => ({
  lightBackground: {
    backgroundColor: `${theme.palette.primary.main}16`,
  },
}));

export default function AlcoholDrugAbuse(props) {

  const classes = useStyles();

  const { register, errors, handleSubmit, setValue, triggerValidation, reset } = useForm({
    validationSchema: AlcoholDrugAbuse.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  };


  useEffect(() => {
    register({ name: 'lastAlcohoSubstandAbuseMonth' });
    setValue('lastAlcohoSubstandAbuseMonth', props.formState.lastAlcohoSubstandAbuseMonth);

    register({ name: 'lastAlcohoSubstandAbuseYear' });
    setValue('lastAlcohoSubstandAbuseYear', props.formState.lastAlcohoSubstandAbuseYear);

    register({ name: 'requireAdditionalAlcoholSubstanceAbuseTreatment' });
    setValue('requireAdditionalAlcoholSubstanceAbuseTreatment', props.formState.requireAdditionalAlcoholSubstanceAbuseTreatment);
  }, [register]);

  return (
    <ThemeProvider theme={(theme) => createTheme({
      ...theme,
      ...InputTheme(),
    })}>
      <Container className="alcohol-drug-abuse-form personalize-step">
        <Form onSubmit={handleSubmit(props.onNext)}>
          <Row className="justify-content-center">
            <Col lg={5}>
              <Row className="justify-content-center pt-2">
                <div className={`icon-container ${classes.lightBackground}`}>
                  <SvgIcon component={BeerBottelGlassIcon} fontSize="large" color="primary" />
                </div>
              </Row>
              <Row className="justify-content-center mainTitle">
                <h4>Alcohol or drug abuse</h4>
              </Row>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg={5}>
            <p className="formElementTitle">I was last treated for alcohol/ subtance abuse on</p>
              <Row>
                <Col lg={6}>
                  <SelectInput
                    name="lastAlcohoSubstandAbuseMonth"
                    id="lastAlcohoSubstandAbuseMonth"
                    value={props.formState.lastAlcohoSubstandAbuseMonth}
                    onChange={(e) => handleValueChange('lastAlcohoSubstandAbuseMonth', e.target.value)}
                    label="Month"
                    inputRef={register}
                    selectOptions={getMonth()}
                    errors={errors && errors.lastAlcohoSubstandAbuseMonth}
                  />
                </Col>
                <Col lg={6}>
                  <SelectInput
                    name="lastAlcohoSubstandAbuseYear"
                    id="lastAlcohoSubstandAbuseYear"
                    value={props.formState.lastAlcohoSubstandAbuseYear}
                    onChange={(e) => handleValueChange('lastAlcohoSubstandAbuseYear', e.target.value)}
                    label="Year"
                    inputRef={register}
                    selectOptions={getYear()}
                    errors={errors && errors.lastAlcohoSubstandAbuseYear}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="justify-content-center pt-3">
            <Col lg={5}>
              <p className="formElementTitle">I require treatment</p>
              <StyledRadioInput
                lable="I require Treatment"
                name="requireAdditionalAlcoholSubstanceAbuseTreatment"
                id="requireAdditionalAlcoholSubstanceAbuseTreatment"
                value={props.formState.requireAdditionalAlcoholSubstanceAbuseTreatment}
                options={[
                  { value: 'true', label: 'Yes' },
                  { value: 'false', label: 'No' },
                ]}
                onChange={(e) => handleValueChange('requireAdditionalAlcoholSubstanceAbuseTreatment', e)}
                errors={errors.requireAdditionalAlcoholSubstanceAbuseTreatment}
                isBlankIcon={true}
              />
            </Col>
          </Row>
          {/* Buttons */}
          <Row className="pre-quote-nav-control">
            <Col className="text-left btn-back">
              <Button variant="outlined" size="medium" color="primary" className="px-4" onClick={props.onBack}>
                BACK
              </Button>
            </Col>
            <Col className="text-right">
              <Button variant="contained" size="medium" color="primary" type="submit" className="px-4">
                NEXT
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </ThemeProvider>
  );
}

AlcoholDrugAbuse.ValidationSchema = object().shape({
    lastAlcohoSubstandAbuseMonth:string().required('Please select the month'),
    lastAlcohoSubstandAbuseYear:string().required('Please select the year'),
    requireAdditionalAlcoholSubstanceAbuseTreatment:string().required('Please choose Yes or No!')
});
AlcoholDrugAbuse.DefaultFormState = (prefill = false, basicInfo = null) => {
  return {
    lastAlcohoSubstandAbuseMonth:'',
    lastAlcohoSubstandAbuseYear:'',
    requireAdditionalAlcoholSubstanceAbuseTreatment:''
  };
};


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/AlcoholDrugAbuse.js